import { render, staticRenderFns } from "./DatafieldEditPopup.vue?vue&type=template&id=01523e7c"
import script from "./DatafieldEditPopup.vue?vue&type=script&lang=js"
export * from "./DatafieldEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports